/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 as Typography } from '@coursera/cds-core';

import _t from 'i18n!nls/reviews';

type ToggleButtonForTogglableContentProps = {
  collapsed: boolean;
};

const styles = {
  label: css`
    color: var(--cds-color-interactive-primary);
  `,
};

const ToggleButtonForTogglableContent = ({ collapsed }: ToggleButtonForTogglableContentProps) => {
  return (
    <React.Fragment>
      {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
      <Typography variant="actionSecondary" component="span" css={styles.label}>
        {collapsed ? _t('Show more') : _t('Show less')}
      </Typography>
    </React.Fragment>
  );
};

export default ToggleButtonForTogglableContent;
